import React, { useState, useEffect } from 'react';
import { Box, Title, Table, Button, Badge, Group, Text, Alert, ActionIcon } from '@mantine/core';
import { IconCheck, IconX, IconVideo } from '@tabler/icons-react';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.ailinkb.shop';

export default function AdminSkillsTab({ adminEmail }) {
  const [skills, setSkills] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchSkills();
  }, [adminEmail]);

  const fetchSkills = () => {
    fetch(`${API_BASE_URL}/api/skills/pending?adminEmail=${encodeURIComponent(adminEmail)}`)
      .then(res => res.json())
      .then(data => {
        if (data.error) setError(data.error);
        else setSkills(data);
      })
      .catch(err => setError(err.toString()));
  };

  const updateStatus = (id, status) => {
    fetch(`${API_BASE_URL}/api/skills/${id}/status`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ adminEmail, status })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          fetchSkills();
        } else {
          setError(data.error);
        }
      })
      .catch(err => setError(err.toString()));
  };

  return (
    <Box p="md">
      <Title order={3} mb="md">Oczekujące Skille AI do Weryfikacji</Title>
      {error && <Alert color="red" mb="md">{error}</Alert>}
      
      {skills.length === 0 ? (
        <Text c="dimmed">Brak skilli oczekujących na akceptację.</Text>
      ) : (
        <Table striped highlightOnHover withTableBorder withColumnBorders>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>ID</Table.Th>
              <Table.Th>Tytuł</Table.Th>
              <Table.Th>Wideo (URL)</Table.Th>
              <Table.Th>Zgłaszający</Table.Th>
              <Table.Th>Cena (EUR)</Table.Th>
              <Table.Th>Akcje</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {skills.map(skill => (
              <Table.Tr key={skill.id}>
                <Table.Td>{skill.id}</Table.Td>
                <Table.Td>{skill.title}</Table.Td>
                <Table.Td>
                  <a href={skill.videoUrl?.startsWith('/') ? `${API_BASE_URL}${skill.videoUrl}` : skill.videoUrl} target="_blank" rel="noreferrer">
                    <Button variant="light" size="xs" leftSection={<IconVideo size={14} />}>Podgląd</Button>
                  </a>
                </Table.Td>
                <Table.Td>{skill.ownerEmail}</Table.Td>
                <Table.Td>{skill.price}</Table.Td>
                <Table.Td>
                  <Group gap="xs">
                    <Button color="green" size="xs" leftSection={<IconCheck size={14} />} onClick={() => updateStatus(skill.id, 'APPROVED')}>Zatwierdź</Button>
                    <Button color="red" size="xs" leftSection={<IconX size={14} />} onClick={() => updateStatus(skill.id, 'REJECTED')}>Odrzuć</Button>
                  </Group>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Box>
  );
}
